import moment from 'moment';
import 'moment/locale/ko';
import { useState } from 'react';
import { BASE_URL, contactMethodMap } from '../shared/constants/app';
import { jwtDecode } from 'jwt-decode';

export const getImageSrc = (folderName, imageName) => {
    if (!imageName) return;
    return `${BASE_URL}/${folderName}/${imageName}`;
};

// Function to handle updating checked values
export const getCheckBoxValues = (checkedValues, name, value, checked) => {
    let updatedValues = [...(checkedValues[name] || [])];

    updatedValues = checked ? [...updatedValues, value] : updatedValues.filter((val) => val !== value);

    const newCheckedValues = { ...checkedValues };
    if (updatedValues.length === 0) {
        delete newCheckedValues[name];
    } else {
        newCheckedValues[name] = updatedValues;
    }

    return newCheckedValues;
};

export const formatNumberWithCommas = (number) => {
    if (number == null) return '';
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatNumberWithCommasEliminateDecimal = (number) => {
    if (number == null || isNaN(Number(number))) return '-';

    return Math.floor(number)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatDateTime = (dateTime) =>
    dateTime ? moment(dateTime).locale('ko').format('YYYY-MM-DD a hh:mm:ss') : '';
export const formatDate = (date) => (date ? moment(date).locale('ko').format('YYYY-MM-DD') : '');
export const formatDatePayload = (date) => {
    return moment(date).format('YYYY-MM-DD');
};

export const decodeHTMLEntities = (text) => {
    if (!text || typeof text !== 'string') return '';

    const entitiesMap = {
        '&nbsp;': ' ',
        comma: ',',
        // Thêm các thực thể khác nếu cần
    };

    return text.replace(/\bcomma\b|&[a-zA-Z]+;/g, (entity) => entitiesMap[entity] || entity);
};

export const handlePrint = (printRef, removeItem) => {
    if (!printRef.current) return;

    const printContent = printRef.current;
    const clonedContent = printContent.cloneNode(true);

    if (Array.isArray(removeItem)) {
        removeItem.forEach((selector) => {
            const elements = clonedContent.querySelectorAll(selector);
            elements.forEach((element) => {
                element.remove();
            });
        });
    }

    const printWindow = window.open('', '_blank', 'width=1200,height=650');
    const printDocument = printWindow.document;
    printDocument.open();
    printDocument.write(
        `<!DOCTYPE html><html lang="ko"><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width,initial-scale=1"><meta name="keywords" content="덴탈잡,치과계구인구직,신흥,dentaljob,치과계대표,전문취업정보"><meta name="description" content="덴탈잡 홈페이지"><title>덴탈잡 - 대한민국 치과계 NO.1 구인구직 사이트 DentalJob.co.kr</title><link rel="stylesheet" href="css/bootstrap/bootstrap.css"><link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"><link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"><link rel="stylesheet" href="css/master.css"><link rel="stylesheet" href="css/style.css"><link rel="stylesheet" href="css/animations.css"><link rel="stylesheet" href="css/print.css" media="print"><script src="js/jquery-3.7.1.js"></script><script src="js/bootstrap/bootstrap.js"></script><style>@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Light.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Light.woff) format('woff'),url(fonts/Pretendard/Pretendard-Light.ttf) format('truetype');font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Regular.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Regular.woff) format('woff'),url(fonts/Pretendard/Pretendard-Regular.ttf) format('truetype');font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Medium.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Medium.woff) format('woff'),url(fonts/Pretendard/Pretendard-Medium.ttf) format('truetype');font-weight:500;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-SemiBold.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-SemiBold.woff) format('woff'),url(fonts/Pretendard/Pretendard-SemiBold.ttf) format('truetype');font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Bold.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Bold.woff) format('woff'),url(fonts/Pretendard/Pretendard-Bold.ttf) format('truetype');font-weight:700;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-ExtraBold.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-ExtraBold.woff) format('woff'),url(fonts/Pretendard/Pretendard-ExtraBold.ttf) format('truetype');font-weight:800;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Black.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Black.woff) format('woff'),url(fonts/Pretendard/Pretendard-Black.ttf) format('truetype');font-weight:900;font-style:normal;font-display:swap}@font-face{font-family:'Jeju Myeongjo';src:url(fonts/JejuMyeongjo/JejuMyeongjoOTF.otf) format('opentype'),url(fonts/JejuMyeongjo/JejuMyeongjo.ttf) format('truetype');font-weight:400;font-style:normal;font-display:swap}</style></head><body>${clonedContent.innerHTML}</body></html>`,
    );
    printDocument.close();

    printWindow.focus();
    setTimeout(() => printWindow.print(), 500);
};

export const parseResumeSchoolInfo = (info) => {
    const [fromYears, fromMonths, toYears, toMonths, names, yearStudyDurations, majors, statuses, gpas, gpaScales] =
        info.split('|').map((item) => item.split(','));

    const schoolInfo = [];

    for (let i = 0; i < fromYears.length; i++) {
        schoolInfo.push({
            from: `${fromYears[i]}.${fromMonths[i]}`,
            to: `${toYears[i]}.${toMonths[i]}`,
            name: names[i],
            yearStudyDuration: yearStudyDurations[i],
            major: majors[i],
            status: statuses[i],
            gpa: gpas[i],
            gpaScale: gpaScales[i],
        });
    }

    return schoolInfo;
};

export const parseResumeCareerInfo = (info) => {
    const [
        fromYears = [],
        fromMonths = [],
        toYears = [],
        toMonths = [],
        locations = [],
        businessNames = [],
        responsibilities = [],
        etcs = [],
        reasonsLeave = [],
        working = [],
    ] = info.split('|').map((item) => item.split('###'));
    const careerInfo = [];
    for (let i = 0; i < fromYears.length; i++) {
        careerInfo.push({
            from: `${fromYears[i]}.${fromMonths[i]}`,
            to: `${toYears[i]}.${toMonths[i]}`,
            businessName: businessNames[i] || '',
            location: locations[i] || '',
            respon: responsibilities[i] || '',
            etc: etcs[i] || '',
            reasonLeave: reasonsLeave[i] || '',
            working: working[i],
        });
    }
    return careerInfo;
};

export const parseResumeLicenseInfo = (info) => {
    const [years = [], months = [], names = [], agencies = [], licenseType = [], licenseNumber = []] = info
        .split('|')
        .map((item) => item.split('###'));

    const licenceInfo = [];

    for (let i = 0; i < years.length; i++) {
        licenceInfo.push({
            yearMonth: `${years[i]}.${months[i]}`,
            name: names[i],
            agency: agencies[i],
            licenseType: licenseType[i],
            licenseNumber: licenseNumber[i],
        });
    }

    return licenceInfo;
};

export const parseResumeActiveInfo = (info) => {
    const [fromYears = [], fromMonths = [], toYears = [], toMonths = [], places = [], contents = [], types = []] = info
        .split('|')
        .map((item) => item.split('###'));

    const activeInfo = [];

    for (let i = 0; i < fromYears.length; i++) {
        activeInfo.push({
            yearMonthStart: `${fromYears[i]}.${fromMonths[i]}`,
            yearMonthEnd: `${toYears[i]}.${toMonths[i]}`,
            place: places[i],
            content: contents[i],
            type: types[i],
        });
    }

    return activeInfo;
};

export const formatContactMethod = (methods) => {
    if (!methods) return '';
    return methods
        .split(',')
        .map((method) => contactMethodMap[method] || method)
        .join(', ');
};
export const ImageCheckFallback = ({ folderName, imgName, src, alt, classImg }) => {
    const transparentPixel = './images/transparent.png';
    const [hasError, setHasError] = useState(false);
    const handleError = () => {
        setHasError(true);
    };

    return (
        <>
            {imgName && !hasError ? (
                <img
                    className={classImg ? classImg : ''}
                    src={src || getImageSrc(folderName, imgName)}
                    alt={alt ? alt : ''}
                    onError={handleError}
                />
            ) : (
                <img className={classImg ? classImg : ''} src={transparentPixel} alt={''} />
            )}
        </>
    );
};

export const getResultText = (result) => {
    if (!result) return '';
    switch (result) {
        case 'W':
            return '결과대기중';
        case 'P':
            return '합격';
        case 'F':
            return '불합격';
        case 'C':
            return '지원취소';
        default:
            return '';
    }
};

export const generateYearOptions = (startYear, endYear) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
        years.push({ id: year, option: year.toString(), value: year.toString() });
    }
    return years.reverse();
};

export const handleFocus = (field) => {
    const inputElement = document.getElementById(`${field}`) || document.querySelector(`[name="${field}"]`);
    if (inputElement) {
        inputElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        if (['INPUT', 'SELECT', 'TEXTAREA'].includes(inputElement.tagName)) {
            inputElement.focus();
        } else {
            const focusableChild = inputElement.querySelector('input, select, textarea');
            if (focusableChild) focusableChild.focus();
        }
    }
};

export const formatBizNo = (value) => {
    // Trả về chuỗi rỗng nếu đầu vào không hợp lệ (null, undefined)
    if (!value) return '';

    // 1. Chỉ giữ lại các chữ số
    const digits = value.replace(/\D/g, '');

    // 2. Lấy độ dài chuỗi số
    const len = digits.length;

    // 3. Xử lý trường hợp không có số hoặc quá ít số
    if (len === 0) {
        return '';
    }

    // 4. Áp dụng định dạng dựa trên độ dài
    if (len <= 3) {
        // Nếu chỉ có tối đa 3 số, trả về nguyên dạng
        // Ví dụ: 123 -> 123
        return digits;
    } else if (len <= 5) {
        // Nếu có 4 hoặc 5 số, thêm dấu gạch nối đầu tiên
        // Ví dụ: 12345 -> 123-45
        return `${digits.substring(0, 3)}-${digits.substring(3)}`;
    } else {
        // Nếu có 6 số trở lên, áp dụng định dạng đầy đủ
        // Chỉ lấy tối đa 10 chữ số đầu tiên
        // Ví dụ: 1234567890 -> 123-45-67890
        // Ví dụ: 1234567 -> 123-45-67
        // Ví dụ: 1234567890123 -> 123-45-67890 (bỏ các số thừa)
        return `${digits.substring(0, 3)}-${digits.substring(3, 5)}-${digits.substring(5, 10)}`;
    }
};

export const formatHomeUrl = (url) => {
    if (!url) return null;
    const trimmedUrl = url.trim();

    // nếu URL bắt đầu bằng http:// hoặc https://
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
        return trimmedUrl;
    }

    // nếu URL có định dạng hợp lệ nhưng thiếu http:// hoặc https://
    if (/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(trimmedUrl)) {
        return `https://${trimmedUrl}`;
    }

    // nếu URL không hợp lệ, trả về null
    return null;
};

export const decodeToken = (token) => {
    if (typeof token !== 'string') {
        return;
    }

    try {
        return jwtDecode(token);
    } catch (error) {
        console.error('Invalid token:', error);
        return null;
    }
};

export const getImgFolder = (type) => {
    switch (type) {
        case 'GRAND':
            return 'banner_photo_grand';
        case 'GRANDSUB':
            return 'banner_photo_grand';
        case 'LOGIN':
            return 'banner_photo_login';
        case 'MAIN':
            return 'banner_photo_main';
        case 'CORP':
            return 'banner_photo_corp';
        case 'MAINRESUME':
            return 'banner_photo_mainresume';
        case 'MAINTOP':
            return 'banner_photo_maintop';
        case 'PREMIUM':
            return 'banner_photo_premium';
        case 'RECRUIT':
            return 'banner_photo_recruit';
        case 'RESUME':
            return 'banner_photo_resume';
        case 'QUICK':
            return 'banner_photo_quick';
        case 'LNB':
            return 'banner_photo_lnb';
        default:
            return '';
    }
};
